import { DEFAULT_SEARCH_PATH } from 'common/constants/paths';

import { patchUrlByLocale } from './patch-url-by-locale';

export const getSRPSuggestionUrl = (searchHref: string, name: string, suggest = true): string => {
  const baseUrl = searchHref || DEFAULT_SEARCH_PATH;
  const suggestParam = suggest ? '&suggest=true' : '';
  const url = `${baseUrl}?q=${encodeURIComponent(name)}${suggestParam}`;
  return patchUrlByLocale({ url });
};
